import { CardMedia, Grid, InputAdornment } from '@mui/material';
import { Notes, ProceedSaveLater, SubHeading } from './components';
import { MFTextField } from '../../lib/formik';
import { Formik, FormikHandlers, FormikHelpers, validateYupSchema, yupToFormErrors } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  getAddressData,
  getAddressFields,
  getApplicantName,
  preventSpecialCharacters,
  saveForLater,
  _updatedAddresses,
  checkForCorrespondenceAddress,
  removeSingleQuote,
  permanentAddressSameAsCorresponding,
  updateAddressDataFunction,
} from '../../utils/utilityFunctions';
import { ApplicantAddressType } from '../../redux-store/types/api-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { contactDetailsSchema } from '../../utils/schema';
import {
  APPLICATION_TYPE,
  USER_ROLES,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  ENABLE_EMAIL_OTP,
} from '../../utils/constant';
import { CountryCodesDropDown, MobileNumberField } from '../commonComponents';
import { getNationalityList } from '../../redux-store/actions';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';

type ContactDetailsProps = {
  phoneNumberoffice: string;
  phoneNumberResidence: string;
  email: string;
  mobile: string;
  countryNameAndCode: string;
  countryCode: string;
  // contactPersonEmail: string;
  // contactPerson1Email: string;
  // primaryContactMobileNo: string;
  // primaryContactCountryCode: string;
  // primaryContactCountryNameAndCode: string;
  applicantAddressSameAsFirstApplicant: boolean;
  faxNumber: string;
  alternateEmailId: string;
  alternateEmailIdNotification: boolean;
  address: {
    permanent?: Partial<ApplicantAddressType>;
    correspondence?: Partial<ApplicantAddressType>;
    [key: string]: Partial<ApplicantAddressType> | string | null | undefined;
  };
};

export type Values = {
  hasPOA: boolean;
  applicants: ContactDetailsProps[];
  saveType: string;
  countryDropdown: string[];
  [key: string]: string | boolean | ContactDetailsProps[] | string[];
};

const initialValues: Values = {
  hasPOA: false,
  applicants: [
    {
      phoneNumberoffice: '',
      phoneNumberResidence: '',
      email: '',
      mobile: '',
      countryNameAndCode: 'India: +91',
      countryCode: '+91',
      faxNumber: '',
      alternateEmailId: '',
      alternateEmailIdNotification: false,
      // contactPersonEmail: '',
      // contactPerson1Email: '',
      // primaryContactMobileNo: '',
      // primaryContactCountryCode: '+91',
      // primaryContactCountryNameAndCode: 'India: +91',
      applicantAddressSameAsFirstApplicant: false,
      address: {
        permanent: getAddressFields('permanent'),
        correspondence: getAddressFields('correspondence'),
      },
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

export const Address = ({
  addressType = '',
  index,
  nationalitiesMdmsResponse,
}: {
  addressType: string;
  index: number;
  nationalitiesMdmsResponse: mdmsCountriesList[];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled =
    ['permanent'].includes(addressType) && [USER_ROLES.POAAPPROVER].includes(role);
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address1`}
          label={`Address Line 1 *`}
          placeholder="Enter Address Line 1"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address2`}
          label={`Address Line 2`}
          placeholder="Enter Address Line 2"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.pincode`}
          label={`Pincode *`}
          placeholder="Enter Pincode"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.city`}
          label={`City *`}
          placeholder="Enter City"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.state`}
          label={`State *`}
          placeholder="Enter State"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* {!nationalitiesMdmsResponse && (
          <MFTextField
            name={`applicants.${index}.address.${addressType}.country`}
            label={`Country *`}
            placeholder="Enter Country"
            disabled={isFieldDisabled}
          />
        )} */}
        {/* {nationalitiesMdmsResponse && ( */}
        <SearchableSelect
          name={`applicants.${index}.address.${addressType}.country`}
          label="Country *"
          items={nationalitiesMdmsResponse.map((nationality) => ({
            key: nationality.name,
            value: nationality.name,
          }))}
          disabled={isFieldDisabled}
          searchFieldPlaceholder={'Search Country'}
        />
        {/* )} */}
      </Grid>
    </>
  );
};

const ApplicantDetails = ({
  values,
  handleChange,
  setValues,
  mdmsCountriesList,
}: {
  values: Values;
  handleChange: FormikHandlers['handleChange'];
  setValues: FormikHelpers<Values>['setValues'];
  mdmsCountriesList: mdmsCountriesList[];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <React.Fragment>
      {values.applicants.map((applicant, index) => (
        <React.Fragment key={index}>
          <SubHeading>Contact details of {getApplicantName(index + 1)} Applicant</SubHeading>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.email`}
              label="Primary E-Mail ID *"
              placeholder="Enter Primary E-Mail ID"
              disabled
              startAdornment={
                <InputAdornment position="start">
                  <CardMedia component="img" alt="Email Icon" src="/images/email.svg" />
                </InputAdornment>
              }
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.contactPersonEmail`}
              label="Primary Contact Person E-Mail ID"
              placeholder="Enter Primary Contact Person E-Mail ID"
              disabled={[ USER_ROLES.POAAPPROVER].includes(role)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.contactPerson1Email`}
              label="Primary Contact Person Alternate E-Mail ID"
              placeholder="Enter Primary Contact Person Alternate E-Mail ID"
              disabled={[ USER_ROLES.POAAPPROVER].includes(role)}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <MobileNumberField
              name={`applicants.${index}.mobile`}
              countryCodeFieldName={`applicants.${index}.countryNameAndCode`}
              countryCodeValue={values.applicants[index].countryNameAndCode}
              label="Mobile *"
              placeholder="Enter Mobile"
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.alternateEmailId`}
              label={`Alternate E-Mail ID${
                values.applicants[index].alternateEmailIdNotification ? ' *' : ''
              }`}
              placeholder="Enter Alternate E-Mail ID"
              startAdornment={
                <InputAdornment position="start">
                  <CardMedia component="img" alt="Email Icon" src="/images/email.svg" />
                </InputAdornment>
              }
            />
            <MFCheckbox
              label="Send portfolio related notifications"
              name={`applicants.${index}.alternateEmailIdNotification`}
              onChange={handleChange}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.mobile`}
              label="Mobile *"
              placeholder="Enter Mobile Number"
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              readOnly={values.hasPOA ? false : true}
              startAdornment={
                <CountryCodesDropDown
                  name={`applicants.${index}.countryNameAndCode`}
                  value={values.applicants[index].countryNameAndCode}
                  readOnly={values.hasPOA ? false : true}
                  disabled={[USER_ROLES.INVESTOR].includes(role)}
                />
              }
              disabled={[USER_ROLES.INVESTOR].includes(role)}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.primaryContactMobileNo`}
              label="Primary Contact Person Mobile Number"
              placeholder="Enter Primary Contact Person Mobile Number"
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              startAdornment={
                <CountryCodesDropDown
                  name={`applicants.${index}.primaryContactCountryNameAndCode`}
                  value={values.applicants[index].primaryContactCountryNameAndCode}
                  disabled={[USER_ROLES.INVESTOR].includes(role)}
                />
              }
              disabled={[USER_ROLES.INVESTOR].includes(role)}
              type="number"
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.faxNumber`}
              label="Fax Number"
              placeholder="Enter Fax Number"
              // type="number"
              // trimOnBlur={false}
              startAdornment={
                <InputAdornment position="start">
                  <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.phoneNumberResidence`}
              label="Telephone (Home)"
              placeholder="Enter Telephone (Home)"
              // type="number"
              // onKeyDown={(e) => {
              //   allowOnlyNumbers(e);
              // }}
              // trimOnBlur={false}
              startAdornment={
                <InputAdornment position="start">
                  <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.phoneNumberoffice`}
              label="Telephone (Office)"
              placeholder="Enter Telephone (Office)"
              // type="number"
              // onKeyDown={(e) => {
              //   allowOnlyNumbers(e);
              // }}
              // trimOnBlur={false}
              startAdornment={
                <InputAdornment position="start">
                  <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
                </InputAdornment>
              }
            />
          </Grid>
          {index > 0 && (
            <MFCheckbox
              onChange={({ target: { checked } }) =>
                setValues({
                  ...values,
                  applicants: values.applicants.map((_applicant, _index) => {
                    if (_index === index) {
                      return {
                        ..._applicant,
                        applicantAddressSameAsFirstApplicant: checked,
                        address: {
                          ..._applicant.address,
                          correspondence: {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            ..._applicant.address.correspondence!,
                          },
                          permanent: {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            ..._applicant.address.permanent!,
                          },
                          ...(!checked && { permanent: getAddressFields('permanent') }),
                          ...(!checked && { correspondence: getAddressFields('correspondence') }),
                        },
                      };
                    }
                    return _applicant;
                  }),
                })
              }
              name={`applicants.${index}.applicantAddressSameAsFirstApplicant`}
              label={`Whether address of ${getApplicantName(
                index + 1
              )} applicant is same as First applicant`}
              sx={{ ml: '40px' }}
              disabled={[USER_ROLES.POAAPPROVER].includes(role)}
            />
          )}
          {/* {applicant.address.nationality?.toLowerCase() !== 'indian' && (
            <React.Fragment>
              <SubHeading>Overseas Address of {getApplicantName(index + 1)} Applicant</SubHeading>
              <Address
                addressType={'overseas'}
                index={index}
                nationalitiesMdmsResponse={mdmsCountriesList}
              />
            </React.Fragment>
          )} */}

          {!applicant.applicantAddressSameAsFirstApplicant && (
            <>
              <SubHeading>
                Correspondence Address of {getApplicantName(index + 1)} Applicant
              </SubHeading>
              <Address
                addressType={'correspondence'}
                index={index}
                nationalitiesMdmsResponse={mdmsCountriesList}
                key={values.applicants.length}
              />
              <MFCheckbox
                onChange={({ target: { checked } }) =>
                  setValues({
                    ...values,
                    applicants: values.applicants.map((_applicant, _index) => {
                      if (_index === index) {
                        return {
                          ..._applicant,
                          address: {
                            ..._applicant.address,
                            correspondence: {
                              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                              ..._applicant.address.correspondence!,
                              permanentAddressSameAsCorresponding: checked,
                            },
                            ...(!checked && { permanent: getAddressFields('permanent') }),
                          },
                        };
                      }
                      return _applicant;
                    }),
                  })
                }
                name={`applicants.${index}.address.correspondence.permanentAddressSameAsCorresponding`}
                label={'Permanent address same as correspondence address.'}
                sx={{ ml: '40px' }}
                disabled={[USER_ROLES.POAAPPROVER].includes(role)}
              />
              {!values.applicants[index]?.address?.correspondence
                ?.permanentAddressSameAsCorresponding && (
                <>
                  <SubHeading>
                    Permanent Address of {getApplicantName(index + 1)} Applicant
                  </SubHeading>
                  <Notes displayContent="No P.O. Box address accepted  for registration purposes" />
                  <Address
                    addressType={'permanent'}
                    index={index}
                    nationalitiesMdmsResponse={mdmsCountriesList}
                  />
                </>
              )}
            </>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

export default function ContactDetails(): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [contactDetails, setContactDetails] = useState(initialValues);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { saveType = '' } = values;
      const updatePayload = applicants.map((applicant, index: number) => {
        const { address: updatedAddresses = {}, ...rest } = values.applicants[index] || {};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { nationality, status, ...addressProps } = updatedAddresses;
        return {
          ...applicant,
          ...rest,
          email: removeSingleQuote(rest.email),
          countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
          // primaryContactCountryCode: rest.primaryContactCountryNameAndCode?.split(':')[1].trim(),
          addresses: Object.keys(updatedAddresses)
            .map((addressType) => {
              if (
                addressType === 'permanent' &&
                updatedAddresses['correspondence']?.permanentAddressSameAsCorresponding
              ) {
                // eslint-disable-next-line
                return permanentAddressSameAsCorresponding(
                  updatedAddresses['correspondence'],
                  addressType,
                  applicant.addresses
                );
              }
              if (
                Object.keys(updatedAddresses).length === 1 &&
                updatedAddresses['correspondence']?.permanentAddressSameAsCorresponding
              ) {
                return [
                  {
                    ...permanentAddressSameAsCorresponding(
                      updatedAddresses['correspondence'],
                      'permanent',
                      applicant.addresses
                    ),
                  },
                  {
                    ...getAddressData(addressType, applicant.addresses),
                    ...(updatedAddresses[addressType] as unknown as Partial<ApplicantAddressType>),
                    address_type: addressType,
                  },
                ];
              }
              return {
                ...getAddressData(addressType, applicant.addresses),
                ...(updatedAddresses[addressType] as unknown as Partial<ApplicantAddressType>),
                address_type: addressType,
              };
            })
            .flat()
            .filter((address) => Object.keys(address).length),
        };
      });

      const UpdateAddressdata = updateAddressDataFunction(updatePayload);
      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants
            ?.map((applicant) => {
              return {
                ...applicant,
                addresses: applicant.addresses?.sort(
                  (address1, address2) => Number(address1.id) - Number(address2.id)
                ),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...application!,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          applicants: UpdateAddressdata.map((applicant) => {
            return {
              ...applicant,
              addresses: applicant?.addresses?.sort(
                (address1, address2) => Number(address1.id) - Number(address2.id)
              ),
            };
          }).sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          currentStep: !!currentStep && currentStep > 2 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              applicants: UpdateAddressdata!,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: 3,
              //!!currentStep && currentStep > 2 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && {
              toastMessage: '',
            }),
          })
        );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
      }
      const routeToSaveForLater = isSaveLater && saveForLater(role, id, applicant1ReferenceId);
      !isSaveLater
        ? history.push('additional-KYC-details', { id, applicant1ReferenceId })
        : routeToSaveForLater && history.push(routeToSaveForLater);
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);
  useEffect(() => {
    const { applicants: exisitingApplicants = [], hasPOA = false } = application || {};
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setContactDetails({
          ...contactDetails,
          hasPOA,
          applicants: exisitingApplicants?.map((applicant) => {
            const {
              phoneNumberoffice = '',
              phoneNumberResidence = '',
              email = '',
              mobile = '',
              countryNameAndCode = 'India: +91',
              applicantAddressSameAsFirstApplicant = false,
              alternateEmailId = '',
              alternateEmailIdNotification = false,
              faxNumber = '',
              // countryCode = '+91',
              // contactPersonEmail = '',
              // contactPerson1Email = '',
              // primaryContactMobileNo = '',
              // primaryContactCountryCode = '+91',
              // primaryContactCountryNameAndCode = 'India: +91',
            } = applicant;
            const correspondence = getAddressData('correspondence', applicant.addresses);
            const permanent = getAddressData('permanent', applicant.addresses);
            const defaultPayload = {
              phoneNumberoffice,
              phoneNumberResidence,
              email,
              applicantAddressSameAsFirstApplicant: applicantAddressSameAsFirstApplicant || false,
              mobile,
              countryNameAndCode: countryNameAndCode ? countryNameAndCode : 'India: +91',
              countryCode: countryNameAndCode ? countryNameAndCode.split(': ')[1] : '+91',
              faxNumber,
              alternateEmailId,
              alternateEmailIdNotification: !!alternateEmailIdNotification,
              // contactPersonEmail,
              // contactPerson1Email,
              // primaryContactMobileNo,
              // primaryContactCountryCode: applicant.primaryContactCountryCode
              //   ? applicant.primaryContactCountryCode
              //   : '+91',
              // primaryContactCountryNameAndCode: applicant.primaryContactCountryNameAndCode
              //   ? applicant.primaryContactCountryNameAndCode
              //   : 'India: +91',
              address: {
                correspondence,
              },
            };
            const permanentAddressPayload = correspondence.permanentAddressSameAsCorresponding
              ? defaultPayload
              : {
                  ...defaultPayload,
                  applicantAddressSameAsFirstApplicant,
                  address: {
                    ...defaultPayload.address,
                    permanent: {
                      ...permanent,
                    },
                    correspondence: {
                      ...correspondence,
                    },
                  },
                };
            return permanentAddressPayload;
          }),
          countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  return (
    <Formik
      initialValues={contactDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, contactDetailsSchema, true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, handleChange, setFieldValue }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <ApplicantDetails
            values={values}
            handleChange={handleChange}
            setValues={setValues}
            mdmsCountriesList={mdmsCountriesList}
          />
          {!!application?.applicants.length && (
            <ProceedSaveLater
              saveLater={() => setFieldValue('saveType', 'save for later')}
              saveAndProceed={() => setFieldValue('saveType', 'save and proceed')}
              loader={loading}
              clickedButton={values.saveType}
            />
          )}
        </Grid>
      )}
    </Formik>
  );
}
